import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "@volca/ui/components/ui/dropdown-menu";
import { FilterChip } from "@volca/ui/components/ui/filter-chip";

const ALL = "all";

/**
 * A filter that takes one value, in the same chip as the many value filter
 * beside it. The menu is a radio group, so the control says out loud that
 * picking a second value replaces the first.
 */
export const FilterChoice = ({
  label,
  options,
  value,
  onChange,
}: {
  label: string;
  options: { id: string; name: string }[];
  value: string | undefined;
  onChange: (id: string | undefined) => void;
}) => (
  <DropdownMenu>
    <DropdownMenuTrigger
      render={
        <FilterChip
          label={label}
          value={options.find((option) => option.id === value)?.name}
          onClear={() => onChange(undefined)}
        />
      }
    />
    <DropdownMenuContent align="start" className="min-w-48">
      <DropdownMenuRadioGroup
        value={value ?? ALL}
        onValueChange={(selected) =>
          onChange(selected === ALL ? undefined : selected)
        }
      >
        <DropdownMenuRadioItem closeOnClick value={ALL}>
          All values
        </DropdownMenuRadioItem>
        {options.map((option) => (
          <DropdownMenuRadioItem closeOnClick key={option.id} value={option.id}>
            {option.name}
          </DropdownMenuRadioItem>
        ))}
      </DropdownMenuRadioGroup>
    </DropdownMenuContent>
  </DropdownMenu>
);
